import React from 'react'
import { connect } from 'react-redux'
import { onNewCitation } from '@chegg-wt/core/state/createCitation/actions'
import { CreateNewCitationPayload } from '@chegg-wt/core/state/bibliography/types'
import { createNewCitation } from '@chegg-wt/core/state/bibliography/actions'
import { AppState } from '@chegg-wt/core/state'
import {
  isDataReadySelector,
  shouldWarnOnCitationCountSelector,
  shouldBlockOnCitationCountSelector,
} from '@chegg-wt/core/state/bibliography/selectors'
import { Config } from '@chegg-wt/core/config'
import {
  origins,
  UserClickPayload,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { CREATE_NEW_CITE_BTN } from '@chegg-wt/core/constants/biblography'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import * as Styled from './styled'

interface Props {
  isDataReady: boolean
  shouldWarn: boolean
  shouldBlock: boolean
  onNewCitation: () => void
  createNewCitation: (payload: CreateNewCitationPayload) => void
  userClick: (payload: UserClickPayload) => void
}

export const CreateCitationButton: React.FunctionComponent<Props> = ({
  isDataReady,
  shouldWarn,
  shouldBlock,
  onNewCitation,
  createNewCitation,
  userClick,
}) => {
  const { bibliographyCitationCountThreshold: blockThreshold } = Config

  const handleClick = () => {
    onNewCitation()
    createNewCitation({
      shouldBlock,
      shouldWarn,
      blockThreshold,
    })

    userClick({ origin: origins.createNewCitationClick })
  }

  return (
    <Styled.CreateCitationButton
      data-test={CREATE_NEW_CITE_BTN}
      onClick={handleClick}
      disabled={!isDataReady}
    >
      Create citation
    </Styled.CreateCitationButton>
  )
}

const mapStateToProps = (state: AppState) => ({
  isDataReady: isDataReadySelector(state),
  shouldWarn: shouldWarnOnCitationCountSelector(state),
  shouldBlock: shouldBlockOnCitationCountSelector(state),
})

const mapDispatchToProps = {
  onNewCitation,
  createNewCitation,
  userClick,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCitationButton)
